module.exports = __webpack_public_path__ + "components/outside-promo-page/static/snow-forecast__icon-2a78472d8f017a3dc709e0f3069f97f9.svg";